﻿import { IComponent, Component, Inject, Input, Output } from "@fiqas/angular-utils";
import { IRoutingComponent, RouteConfig } from "@fiqas/ngcomponentrouter";
import { FIQAssist } from "../../app";
import { IDisposable } from "../../interfaces/general";
import { ServiceCase, ServiceCaseData, ServiceCaseRef } from "../../models/serviceCase";
import { ServiceCaseService } from "../../services/fiqassistApi/serviceCaseService"
import { CacheService } from "../../services/cache";
import { IIdentityLink } from "../../interfaces/iFqs";
import { SaveDialog } from "./savedialog";
import { AuthenticationService } from "../../services/authenticationService";
import { AuthorizationService } from "../../services/authorizationService";
import { Person } from "../../models/person";
import { Customer } from "../../models/customer";

export class ServiceCaseBase<T extends ServiceCase> {
    public static template = "views/servicecase.base.html";

    public selectionList: ServiceCaseRef[] = [];
    public currentCaseIndex: number;
    public isNew: boolean;
    public Title: string = '';
    public activeMenuItem: string;
    public highlightMenuItem: string;
    public collapseInfo = false;

    public get prevCase(): ServiceCaseRef {
        return this.currentCaseIndex > 0 ? this.selectionList[this.currentCaseIndex - 1] : null;
    }
    public get nextCase(): ServiceCaseRef {
        return this.currentCaseIndex < (this.selectionList.length - 1) ? this.selectionList[this.currentCaseIndex + 1] : null;
    }

    constructor(
        protected authorizationService: AuthorizationService,
        protected cacheService: CacheService,
        protected $rootRouter: angular.Router,
        protected $timeout: angular.ITimeoutService,
        protected $location: angular.ILocationService,
    ) {

    }

    public $onInit() {

    }

    public $onDestroy() {
    }

    public get readOnly(): boolean {
        return (!this.data || this.data.status == "closed" || this.data.status == "cancelled") || (!this.authorizationService.currentRoleIn(["CUST", "SD"]));
    }
    public get readOnlyChat(): boolean {
        return (!this.data || this.data.status == "closed" || this.data.status == "cancelled");
    }
    public titleChanged(val: string) {
        if (this.onTitleChanged)
            this.onTitleChanged(val);
    }
    public onTitleChanged: (title: string) => void;

    public async nextPrevClick(direction: 'next' | 'prev') {
        var ni = this.currentCaseIndex + (direction == 'next' ? 1 : -1);
        var ncase = this.selectionList[ni];
        await this.$timeout();
        var parameters = { number: ncase.number };
        if (this.$location.search()['referer'])
            parameters['?referer'] = this.$location.search()['referer'];
        if (ncase.type == 'bug')
            this.$rootRouter.navigate(['Problem', 'Edit', parameters]);
        else
            this.$rootRouter.navigate(['Request', 'Edit', parameters]);
    }

    public updatePrevNext(current: string, id: IIdentityLink) {
        this.currentCaseIndex = -1;
        this.selectionList.forEach((x, n) => {
            if (current ? x.number == current : x.id.fullHref == id.fullHref)
                this.currentCaseIndex = n;
        });
    }

    public $routerOnDeactivate?(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction): ng.IPromise<any> | any {
        this.currentCaseIndex = -1;
        this.isDirty = false;
    }
    /**
     * called to to determine whether a Component can be reused across Route Definitions that match the same type of Component, or whether to destroy and instantiate a new Component every time.
     */
    public $routerCanReuse(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction): ng.IPromise<boolean> | boolean {
        return true;
    }
    /**
     * called by the Router at the end of a successful navigation. Only one of $routerOnActivate and $routerOnReuse will be called depending upon the result of a call to $routerCanReuse.
     */
    public async $routerOnActivate(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
         await this.authorizationService.roleLoaded;
        this.selectionList = this.cacheService.getValue<ServiceCaseRef[]>("servicecases.selected.data") || [];
        var a = next;
    }
    /**
     * called by the Router at the end of a successful navigation. Only one of $routerOnActivate and $routerOnReuse will be called depending upon the result of a call to $routerCanReuse.
     */
    public async $routeOnReuse(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
         await this.authorizationService.roleLoaded;
        var b = next;
    }

    public get isDirty(): boolean {
        return this.authorizationService.dirty;
    }
    public set isDirty(val: boolean) {
        this.authorizationService.dirty = val;
    }

    public async $routerCanDeactivate(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
        return true;
    }

    public static $canActivate = AuthorizationService.RoleCheck;

    public setErrorClass(element, classname: string) {
        angular.element(element[0].getElementsByClassName(classname).item(0)).addClass('error');
    }

    public clearErrorClass(element, classname: string) {
        angular.element(element[0].getElementsByClassName(classname).item(0)).removeClass('error');
    }

    public goHome() {
        this.$rootRouter.navigate(["Home"]);
    }

    private data: T;
    public get Data(): T {
        return this.data;
    }
    public set Data(data: T) {
        this.data = data;
        this.makephonetip();
    }

    protected phonetip: string;
    private async makephonetip() {
        if (!this.data || !this.data.contactPerson) return;
        let title = '';
        let contactPerson: Person = await this.data.contactPerson.value;
        if (contactPerson.phone && contactPerson.phone.length > 0) {
            title = `${contactPerson.name}: ${contactPerson.phone.reverse().join(", ")}`;
        } else {
            let contactCustomer: Customer = await this.data.customer.value;
            if (contactCustomer.phone) {
                title = `${contactCustomer.name}: ${contactCustomer.phone}`;
            } else {
                title = `${contactPerson.name}`;
            }
        }
        this.phonetip = `${title}`;
    }
}
